module.exports = __webpack_public_path__ + "media/Great-great_grandmother.52b7215c.mp3";